import ManageSubscriptionModal from 'components/GlobalModals/ManageSubscriptionModal/ManageSubscriptionModal';
import ManageSubscriptionModalRedesign from 'components/GlobalModals/ManageSubscriptionModal/ManageSubscriptionModalRedesign';

const hasNewDesign =
    typeof Sephora !== 'undefined' && !!Sephora?.configurationSettings?.autoReplenishmentConfigurations?.changeDate?.newDesign?.isEnabled;

export default hasNewDesign ? ManageSubscriptionModalRedesign : ManageSubscriptionModal;
